export default "__VITE_ASSET__By0wpOmC__"